/*
 * This contains all the text for the cart components.
 */

import { defineMessages } from 'react-intl'

export default defineMessages({
  cartDetailsTitle: {
    id: 'app.cart.components.cartDetailsTitle',
    description: 'The title displayed on the cart details view',
  },
  checkoutTitle: {
    id: 'app.cart.components.checkoutTitle',
    description: 'The title displayed on the checkout pages',
  },
  cancelCheckout: {
    id: 'app.cart.components.cancelCheckout',
    description: 'The cancel button in the checkout header',
  },
  additionalDetails: {
    id: 'app.cart.components.additionalDetails',
    description:
      'Additional details button text that expands the additional details accordion',
  },
  detailsLabel: {
    id: 'app.cart.details',
    description: 'Details label used as part of the checkout tabs',
  },
  addressLabel: {
    id: 'app.cart.address',
    description: 'Address label used as part of the checkout tabs',
  },
  paymentLabel: {
    id: 'app.cart.payment',
    description: 'Payment label used as part of the checkout tabs',
  },
  reviewLabel: {
    id: 'app.cart.review',
    description: 'Review label used as part of the checkout tabs',
  },
})



// WEBPACK FOOTER //
// ./src/containers/Cart/messages.js